"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtendNodeMenu = void 0;
const react_1 = __importStar(require("react"));
const index_1 = require("../../../DOM/index");
const index_2 = require("../../../../GraphQL/Resolve/index");
const graphql_zeus_1 = require("graphql-zeus");
const trees_1 = require("../../../../state/containers/trees");
const index_3 = require("../../components/index");
exports.ExtendNodeMenu = ({ hideMenu }) => {
    var _a;
    const { tree, setTree, libraryTree } = trees_1.useTreesState();
    const [menuSearchValue, setMenuSearchValue] = react_1.useState('');
    const allNodes = tree.nodes.concat(libraryTree.nodes);
    return (react_1.default.createElement(index_3.Menu, { onMouseEnter: () => {
            index_1.DOM.scrollLock = true;
        }, onMouseLeave: () => {
            index_1.DOM.scrollLock = false;
        }, onScroll: (e) => e.stopPropagation(), hideMenu: hideMenu },
        react_1.default.createElement(index_3.MenuSearch, { value: menuSearchValue, onChange: setMenuSearchValue, onClear: () => setMenuSearchValue('') }),
        react_1.default.createElement(index_3.MenuScrollingArea, null, (_a = allNodes
            .filter((a) => ![
            graphql_zeus_1.TypeExtension.EnumTypeExtension,
            graphql_zeus_1.TypeExtension.InputObjectTypeExtension,
            graphql_zeus_1.TypeExtension.InterfaceTypeExtension,
            graphql_zeus_1.TypeExtension.ObjectTypeExtension,
            graphql_zeus_1.TypeExtension.ScalarTypeExtension,
            graphql_zeus_1.TypeExtension.UnionTypeExtension,
            graphql_zeus_1.TypeSystemDefinition.DirectiveDefinition,
        ].find((o) => a.data.type === o))) === null || _a === void 0 ? void 0 : _a.sort((a, b) => (a.name > b.name ? 1 : -1)).filter((a) => a.name.toLowerCase().includes(menuSearchValue.toLowerCase())).map((f) => (react_1.default.createElement(index_3.MenuItem, { key: f.name, node: f, onClick: () => {
                tree.nodes.push({
                    data: {
                        type: index_2.ResolveExtension(f.data.type),
                    },
                    description: undefined,
                    type: {
                        name: graphql_zeus_1.TypeDefinitionDisplayMap[index_2.ResolveExtension(f.data.type)],
                    },
                    name: f.name,
                    args: [],
                });
                hideMenu();
                index_1.DOM.scrollLock = false;
                setTree(Object.assign({}, tree));
            } }))))));
};
